import { repeatBuyingDefinition as d } from './repeat-buying-answer.js';
/** One reviewed question projection is shared by the composer and publication boundary. */
export function buildRepeatBuyingPresentation(facts) {
    const copy = d.presentationCopy;
    const counts = facts.counts;
    const customerSource = {
        source: 'customers',
        label: copy.sourceLabel,
        syncedAt: facts.evidence.sourceTimestamps[0].syncedAt,
    };
    const datum = (measurement, label, unit, value) => ({
        sourceRef: { measurement },
        label,
        unit,
        result: { state: 'available', value },
    });
    const unavailableShare = {
        sourceRef: { measurement: 'repeatShare' },
        label: copy.zeroBuyersExplanation,
        unit: 'proportion',
        result: { state: 'unavailable', reason: 'zero_base', message: copy.zeroBuyers },
    };
    const note = (code, text, values = [], sources = []) => ({ code, text, values, sources });
    const notes = [
        note('lifetime_basis', 'Based on lifetime order counts saved on customer profiles.', [], [customerSource]),
        note('known_order_profiles', copy.knownProfiles, [
            datum('knownOrderProfiles', copy.knownProfiles, 'count', facts.coverage.knownOrderProfiles),
        ]),
        ...(counts.unknownOrderProfiles > 0
            ? [
                note('unknown_order_profiles', copy.unknownProfiles, [
                    datum('unknownOrderProfiles', copy.unknownLabel, 'count', counts.unknownOrderProfiles),
                ]),
            ]
            : []),
        ...(counts.knownBuyers === 0 ? [note('zero_known_buyers', copy.zeroBuyers)] : []),
        ...(customerSource.syncedAt === null ? [note('missing_source_sync', copy.noSync, [], [customerSource])] : []),
    ];
    const shareCard = facts.repeatShare.state === 'unavailable'
        ? { kind: 'metric', datum: unavailableShare, emphasis: 'primary' }
        : {
            kind: 'metric',
            datum: datum('repeatShare', copy.shareLabel, 'proportion', facts.repeatShare.value),
            values: [
                datum('repeatBuyers', copy.repeatLabel, 'count', counts.repeatBuyers),
                datum('knownBuyers', copy.buyerUnit, 'count', counts.knownBuyers),
            ],
            emphasis: 'primary',
        };
    return {
        sections: [
            {
                id: 'repeat-buying',
                title: copy.title,
                help: {
                    appliesTo: [{ measurement: 'repeatShare' }, { measurement: 'knownBuyers' }],
                    why: copy.why,
                    how: copy.how,
                    notes,
                },
                cards: [
                    shareCard,
                    {
                        kind: 'population-steps',
                        relationship: 'nested-sets',
                        base: datum('totalProfiles', copy.profileLabel, 'count', counts.totalProfiles),
                        steps: [
                            { datum: datum('totalProfiles', copy.profileLabel, 'count', counts.totalProfiles) },
                            { datum: datum('knownBuyers', copy.buyerLabel, 'count', counts.knownBuyers) },
                            { datum: datum('repeatBuyers', copy.repeatLabel, 'count', counts.repeatBuyers), emphasis: 'primary' },
                        ],
                    },
                ],
            },
        ],
    };
}
//# sourceMappingURL=repeat-buying-presentation.js.map